var testDivElement = document.getElementById('prntdiv');

function savePDF() {
    var imgData;
    html2canvas($("#prntdiv"), {
        useCORS: true,
        onrendered: function (canvas) {
            imgData = canvas.toDataURL(
                'image/png');
                var doc = new jsPDF('p', 'pt', [720, 774.75]);
                doc.addImage(imgData, 'PNG', 0, 0);
                doc.save('combobuilder-results.pdf');
                    //setTimeout(function () { window.open(imgData) }, 1000);
                }
            });
        }


$(document).ready(function(){
    function blink(){
        // $(gdis).append( "<p>Test</p>" );
        $("#prntdiv").find("[data-element='oct-quiz-resultWrapper oct-quiz-media']").append("<div data-element='oct-quiz-btn oct-quiz-media' data-display='' class='blcksbtn'><button class='prntbtn' title='' onclick='savePDF()'>Print Results</button></div>");
        $(".blcksbtn:not(:first)").remove();
    }
    setInterval(blink,1000);
});


